// import { bankAccountCommon } from '@repo/api/endpoints/common-data.mock';
// import type { MerchantResponse } from '@repo/api/endpoints/merchant';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var MERCHANT_SANDBOX = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['liberis', 'pragma'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'user',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: true,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [
            {
                id: 12345,
                min: 3000,
                max: 50000,
                currency: 'PLN',
                provider: 'liberis',
                availableLimitRevenueRate: [
                    {
                        period: 0,
                        pricing: 0,
                        loanRepaymentPrice: 0,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
            {
                id: 1732011441,
                min: 3000,
                max: 70000,
                currency: 'PLN',
                provider: 'pragma',
                availableLimitRevenueRate: [
                    {
                        period: 2,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 3000,
                        amountMax: 5000,
                    },
                    {
                        period: 4,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 3000,
                        amountMax: 10000,
                    },
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 70000,
                    },
                ],
            },
        ],
        limits: [
            // {
            //   id: 1732011441,
            //   preLimitId: 1732011441,
            //   min: 3000,
            //   max: 51000,
            //   used: 51000,
            //   currency: 'PLN',
            //   provider: 'liberis',
            //   availableLimitRevenueRate: [
            //     {
            //       period: 2,
            //       pricing: 30,
            //       loanRepaymentPrice: 3.6,
            //       amountMin: 10000,
            //       amountMax: 20000,
            //     },
            //     {
            //       period: 12,
            //       pricing: 30,
            //       loanRepaymentPrice: 3.6,
            //       amountMin: 10000,
            //       amountMax: 20000,
            //     },
            //   ],
            //   minMaxDifference: false,
            //   available: 0,
            // },
            {
                id: 1732011441,
                preLimitId: 1732011441,
                min: 3000,
                max: 70000,
                used: 0,
                currency: 'PLN',
                provider: 'pragma',
                availableLimitRevenueRate: [
                    {
                        period: 2,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 3000,
                        amountMax: 5000,
                    },
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 70000,
                    },
                ],
                minMaxDifference: false,
                available: 70000,
            },
        ],
        loans: [
        // {
        //   id: 32,
        //   limitId: 30,
        //   amount: 50000,
        //   currency: 'PLN',
        //   period: 4,
        //   pricing: 1.15,
        //   loanRepaymentPrice: 22,
        //   name: 'BCA',
        //   iban: 'PL67881000071602170257312605',
        //   createdAt: '2025-07-18 14:43:06',
        //   provider: 'pragma',
        //   stage: 5,
        //   providerRequest: 'requested',
        //   sms: [],
        //   loanRepaymentAccounts: [123456],
        //   previousStage: 4,
        //   documents: [
        //     {
        //       url: 'https://sandbox.liberis.com/#/contract?applicationId=fd126768-67f5-4e26-b0c5-4b69ca332a42',
        //       type: 'liberis',
        //     },
        //   ],
        //   loanAmountChange: false,
        //   rejectionDescription: null,
        //   status: 'DONE',
        // },
        ],
        agreements: {
            marketing: [
                {
                    provider: 'przelewy24',
                    accepted: false,
                    timestamp: '2024-05-16T07:38:18.593Z',
                },
            ],
        },
        transfers: [],
        offers: [
        // {
        //   provider: 'liberis',
        //   preLimitId: 17272,
        //   offerId: '17272',
        //   amount: 70000,
        //   currency: 'PLN',
        //   period: 12,
        //   pricing: 17.5,
        //   loanRepaymentPrice: 11.76,
        //   name: 'KBCAG',
        //   createdAt: '2025-01-30 12:13:32',
        //   amountMax: 70000,
        //   amountMin: 3000,
        // },
        ],
    }, config: [
        __assign(__assign({}, configCommon[0]), { provider: 'liberis', default: false }),
        __assign(__assign({}, configCommon[0]), { provider: 'pragma', default: false }),
    ] });
